// extracted by mini-css-extract-plugin
export default {"CreateDialogTool":"CreateDialogTool_CreateDialogTool__ltYaN"};